import FooterDarkContainer from "../../Componant/PageLayout/FooterDark";

const FooterDark = () => {
  return (
    <div className="page-body">
      <FooterDarkContainer />
    </div>
  );
};

export default FooterDark;
